import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import Button from "../../components/Button";
import SingleBlog from "../../components/Blog";
import config from "../../config";
import makeRequest from "../../makeRequest";

import shapeImg from "../../assets/img/about/shape-2-1.png";
import fallbackImg from "../../assets/img/blog/blog-1-1.jpg";

function BlogCard({ blog }) {
  const [imgSrc, setImgSrc] = useState(null);

  useEffect(() => {
    if (!blog.hasImage1) return;
    let objectUrl = null;
    let cancelled = false;
    fetch(`${config.api.baseUrl}/website/blog/${blog.id}/image/image1`)
      .then((r) => {
        if (!r.ok) throw new Error();
        return r.blob();
      })
      .then((blob) => {
        if (!cancelled) {
          objectUrl = URL.createObjectURL(blob);
          setImgSrc(objectUrl);
        }
      })
      .catch(() => {});
    return () => {
      cancelled = true;
      if (objectUrl) URL.revokeObjectURL(objectUrl);
    };
  }, [blog.id, blog.hasImage1]);

  const date = new Date(blog.createdAt);
  const day = date.getDate();
  const month = date.toLocaleString("default", { month: "short", year: "2-digit" });

  return (
    <SingleBlog
      blogImage={imgSrc || fallbackImg}
      publishedDate={String(day)}
      publishedMonth={month}
      authorName={blog.name || "Maroof"}
      titleClass="hover-anim green"
      title={blog.title || blog.name}
      btnText="Read More"
      blogId={blog.id}
    />
  );
}

const Blog = () => {
  const [blogs, setBlogs] = useState([]);

  useEffect(() => {
    makeRequest({ route: "/website/blog?perPage=3&isActive=1", method: "get" })
      .then((data) => setBlogs(data?.data?.slice(0, 3) || []))
      .catch(() => {});
  }, []);

  if (blogs.length === 0) return null;

  const delays = [".3s", ".5s", ".7s"];

  return (
    <div id="it-blog" className="it-blog-area it-blog-style-2 fix p-relative pt-75 pb-90">
      <div className="container">
        <div className="it-blog-title-box mb-65">
          <div className="row align-items-end">
            <div className="col-xl-7 col-lg-6 col-md-6">
              <div>
                <span className="mh-lf-section__eyebrow">
                  <svg viewBox="0 0 20 20" fill="currentColor" aria-hidden="true">
                    <path d="M10 2a1 1 0 011 1v5h5a1 1 0 010 2h-5v5a1 1 0 01-2 0v-5H4a1 1 0 010-2h5V3a1 1 0 011-1z" />
                  </svg>
                  Stay Informed Today
                </span>
                <h2 className="mh-lf-section__title" style={{ marginBottom: 0 }}>
                  Our Latest Blogs
                </h2>
              </div>
            </div>
            <div className="col-xl-5 col-lg-6 col-md-6">
              <div className="it-blog-button text-md-end">
                <Link
                  to="/blog"
                  className="it-btn"
                  style={{
                    display: "inline-block",
                    padding: "10px 28px",
                    borderRadius: 6,
                    background: "#076cec",
                    color: "#fff",
                    fontWeight: 600,
                    fontSize: "0.9rem",
                    textDecoration: "none",
                  }}
                >
                  See All Blogs
                </Link>
              </div>
            </div>
          </div>
        </div>
        <div className="row">
          {blogs.map((blog, i) => (
            <div
              key={blog.id}
              className="col-xl-4 col-lg-4 col-md-6 mb-30 wow animate__fadeInUp"
              data-wow-duration=".9s"
              data-wow-delay={delays[i] || ".3s"}
            >
              <BlogCard blog={blog} />
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default Blog;
